import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import EditIcon from "@mui/icons-material/EditOutlined";

const useStyles = makeStyles(theme => ({
  editButton: {
    padding: theme.spacing(1),
    height: 36,
    marginLeft: 70,
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(3)
    }
  },
  editButtonIcon: {
    width: 18,
    height: 18
  }
}));

export default function SlideOutSubtitle(props) {
  const classes = useStyles();
  return (
    <Box display="flex" flexDirection="row">
      <Typography variant="body1" color="textSecondary">
        {props.subtitle}
      </Typography>
      {props.editable && (
        <IconButton
          color="textSecondary"
          className="filled"
          classes={{ label: classes.editButtonIcon, root: classes.editButton }}
          size="large"
        >
          <EditIcon />
        </IconButton>
      )}
    </Box>
  );
}

SlideOutSubtitle.propTypes = {
  content: PropTypes.string,
  editable: PropTypes.bool
};
